<template>
    <design-2021-apprentice-data-table nosearch :fields="fields" :items="logItems"
                                       @row-clicked="rowClicked"></design-2021-apprentice-data-table>
</template>

<script>

import {CommonBus, LogBus} from '../../app';

export default {
    props: ['logItemsByTime', 'paperId'],
    name: 'design-2021-log-time-list-component',
    data() {
        return {
            logItems: this.logItemsByTime,
            selected: null,
            fields: [
                {
                    key: 'name',
                    label: this.$t('log.through')
                },
                {
                    key: 'time_spend_friendly',
                    label: this.$t('log.time_spent')
                }
            ]
        }
    },
    methods: {
        rowClicked(row) {
            this.$emit('row-clicked', row);
        },
        fetchUserTime() {
            let uri = '/log/fetchUserTime/' + this.paperId;

            axios.get(uri).then((response) => {

                let data = response.data;
                const items = (data) ? data.items : [];

                this.logItems = response.data.items;

                CommonBus.$emit('update-logged-time', items);
            });
        },
        updateData(data) {
            this.fetchUserTime(data);
        }
    },
    created() {
        LogBus.$on('pushData', (data) => {
            this.updateData(data);
        });
    }
}
</script>

<style>


</style>
